import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Fade from "react-reveal";
import { Link, useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import { Breadcrumb, BreadcrumbItem, Form, FormGroup, Label } from "reactstrap";
import { APP_INTRO_DETAILS, USER_DETAILS } from "services/ApiCalls";
import {
  catchAsync,
  checkResponse,
  removeUnderScore,
} from "utilities/utilities";
import noImg from "../../../../assets/images/no-img.png";
import moment from "moment";

const AppIntroViewDetails = () => {
  const [data, setData] = useState();
  const { id } = useParams();
  const navigate = useNavigate();

  const getData = catchAsync(async () => {
    const res = await APP_INTRO_DETAILS(id);
    checkResponse({
      res,
      setData: (data) => {
        const dataToSet = data;
        setData(dataToSet);
      },
    });
  });

  useEffect(() => {
    if (id) getData();
  }, [id]);

  console.log(data);

  return (
    <Fade>
      <section className="addresources comon_dashpad">
        <Form>
          <div className="comom_fillter_set text-start">
            <div className="resource_headwrap d-flex align-items-center justify-content-between">
              <h5 className="fillter_head">Preview details</h5>
            </div>

            <div className="breadcrumb_set mt-3">
              <Breadcrumb>
                <BreadcrumbItem onClick={() => navigate(-1)}>
                  <Link to="#">Manage App Intro</Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Preview details</BreadcrumbItem>
              </Breadcrumb>
            </div>

            <div className="addresources_bottom_form rounded-3 p-3">
              <h5 className="text-white"> Content</h5>

              <div className=" d-flex justify-content-center">
  {data?.media_type === "image" ? (
    <img
      src={data?.media || noImg}
      alt="media"
      style={{
        width: "300px",
        height: "300px",
        objectFit: "cover",
        borderRadius: "10px",
      }}
    />
  ) : data?.media_type === "video" ? (
    <video
      width="320"
      height="240"
      controls
      style={{ borderRadius: "10px" }}
    >
      <source src={data?.media} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  ) : (
    <img
      src={noImg}
      alt="no-media"
      style={{ width: "200px", height: "200px", objectFit: "cover" }}
    />
  )}
</div>


              <div className="author_form mt-5">
                <h5 style={{ color: "white" }}>App Intro Details</h5>
                <Row>
                 
                  <Col lg={6} md={6} sm={12}>
                    <FormGroup className="position-relative flex_fields">
                      <Label for="Category">Media Type</Label>
                      <p className="text_line">{data?.media_type || "-"}</p>
                    </FormGroup>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <FormGroup className="position-relative flex_fields">
                      <Label for="Category">Status</Label>
                      <p className="text_line">
                        {data?.status || "-"}
                      </p>
                    </FormGroup>
                  </Col>
                  {/* <Col lg={6} md={6} sm={12}>
                    <FormGroup className="position-relative flex_fields">
                      <Label for="Category">Created At</Label>
                      <p className="text_line">{moment(data?.createdAt).format("YYYY/MM/DD LT")}</p>
                    </FormGroup>
                  </Col>
             */}
                  {data?.description && (
                    <Col sm={12}>
                      <FormGroup className="position-relative flex_fields">
                        <Label for="Category">Description</Label>
                        <p className="text_line">{data?.description}</p>
                      </FormGroup>
                    </Col>
                  )}
                  {data?.short_description && (
                    <Col sm={12}>
                      <FormGroup className="position-relative flex_fields">
                        <Label for="Category">Short Description</Label>
                        <p className="text_line">{data?.short_description}</p>
                      </FormGroup>
                    </Col>
                  )}
                </Row>
                {data?.details && data?.details?.companies?.length !== 0 ? (
                  <>
                    <h5 style={{ color: "white" }}>Experience</h5>

                    {data?.details?.companies?.map((item) => {
                      return (
                        <Row key={item?._id}>
                          <Col lg={6} md={6} sm={12}>
                            <FormGroup className="flex_fields">
                              <Label for="eventname">Company Name</Label>
                              <p className="text_line">{item?.name}</p>
                            </FormGroup>
                          </Col>
                          <Col lg={6} md={6} sm={12}>
                            <FormGroup className="flex_fields">
                              <Label for="eventname">Title</Label>
                              <p className="text_line">{item?.title}</p>
                            </FormGroup>
                          </Col>
                          <Col lg={6} md={6} sm={12}>
                            <FormGroup className="flex_fields">
                              <Label for="eventname">Start Date</Label>
                              <p className="text_line">
                                {moment(item?.startDate).format("YYYY/MM/DD")}
                              </p>
                            </FormGroup>
                          </Col>
                          <Col lg={6} md={6} sm={12}>
                            <FormGroup className="flex_fields">
                              <Label for="eventname">End Date</Label>
                              <p className="text_line">
                                {moment(item?.endDate).format("YYYY/MM/DD")}
                              </p>
                            </FormGroup>
                          </Col>
                          <Col sm={12}>
                            <FormGroup className="position-relative flex_fields">
                              <Label for="Category">Description</Label>
                              <p className="text_line">{item?.description}</p>
                            </FormGroup>
                          </Col>
                        </Row>
                      );
                    })}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </Form>
      </section>
    </Fade>
  );
};

export default AppIntroViewDetails;
